import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "27px",
    height: "100%",
    width: "100%",
    lineHeight: "1.7",
  },
  landscapeContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  landscapeArrowContainer: {
    fontSize: "6px",
    color: "#FF0000",
    alignSelf: "flex-end",
    width: "32px",
  },
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    width: "100%",
    height: "100%",
    lineHeight: "1.7",
  },
  portraitContainer: {
    flexDirection: "column",
  },
  landscapeLeft: {
    flexDirection: "row",
    width: "50%",
  },
  landscapeRight: {
    flexDirection: "row",
    textAlign: "right",
    width: "50%",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "18px",
    height: "15px",
  },
  pointingText: {
    marginBottom: "3px",
    marginTop: "-13px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument28 = ({ arabChunks, engChunks }) => {
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  return (
    <Document>
      <Page size="A5" orientation="landscape" style={Styles.landscapePage}>
        <View style={{ flexDirection: "row", textAlign: "right" }}>
          <View style={{ width: "30px" }}></View>
          <View style={{ flexDirection: "column", width: "90%" }}>
            <View
              style={{
                height: "30px",
                justifyContent: "center",
              }}
            >
              <View
                style={[
                  Styles.landscapeArrowContainer,
                  {
                    width: "25px",
                    marginRight: "-6px",
                    transform: "rotate(-90deg)",
                  },
                ]}
              >
                <Text style={Styles.pointingText}>بداية&nbsp;النص</Text>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[Styles.arrowIcon]}
                ></Image>
              </View>
            </View>
            <View style={{ height: "80%" }}>
              <View
                style={[
                  {
                    textAlign: "right",
                  },
                ]}
              >
                {arabicText(arabChunks[0])}
              </View>
            </View>
            <View style={{ width: "30px" }}></View>
          </View>
          <View style={{ width: "30px" }}></View>
        </View>
      </Page>

      <Page size="A4" style={Styles.portraitPage}>
        <View style={Styles.portraitContainer}>
          <View style={{ margin: "27px", height: "50%" }}>
            <View style={{ flexDirection: "row" }}>
              <View style={{ width: "30px" }}></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View
                  style={{
                    height: "30px",
                    justifyContent: "flex-end",
                    marginBottom: "6px",
                  }}
                >
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={[
                      Styles.arrowIcon,
                      { transform: "rotate(-90deg)", alignSelf: "flex-end" },
                    ]}
                  ></Image>
                </View>
                <View style={{ height: "90%" }}>
                  <View
                    style={[
                      {
                        textAlign: "right",
                      },
                    ]}
                  >
                    {arabicText(arabChunks[1])}
                  </View>
                </View>
                <View
                  style={[
                    Styles.landscapeArrowContainer,
                    { width: "40px", marginTop: "6px" },
                  ]}
                ></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
          <View style={{ margin: "27px", height: "50%" }}>
            <View style={{ flexDirection: "row" }}>
              <View
                style={[
                  Styles.landscapeArrowContainer,
                  { alignSelf: "flex-start" },
                ]}
              >
                <View style={{ transform: "rotate(180deg)" }}>
                  <Text style={[Styles.pointingText, { marginBottom: "6px" }]}>
                    End of text
                  </Text>
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={[Styles.arrowIcon, { alignSelf: "flex-start" }]}
                  ></Image>
                </View>
              </View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View style={{ height: "30px" }}></View>
                <View
                  style={{
                    height: "90%",
                    textAlign: "left",
                    transform: "rotate(180deg)",
                  }}
                >
                  {engChunks[3]?.map((word, idx) => {
                    return (
                      <Text style={{}} key={idx}>
                        {word}
                      </Text>
                    );
                  })}
                </View>
                <View style={{ height: "30px" }}></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.portraitPage}>
        <View style={Styles.portraitContainer}>
          <View style={{ margin: "27px", height: "50%" }}>
            <View style={{ flexDirection: "row" }}>
              <View style={{ width: "30px" }}></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View style={{ height: "30px" }}>
                  <View style={Styles.landscapeArrowContainer}></View>
                </View>
                <View
                  style={{
                    height: "90%",
                    textAlign: "left",
                    transform: "rotate(180deg)",
                  }}
                >
                  {engChunks[2]?.map((word, idx) => {
                    return (
                      <Text style={{}} key={idx}>
                        {word}
                      </Text>
                    );
                  })}
                </View>
                <View
                  style={[
                    Styles.landscapeArrowContainer,
                    { height: "30px", width: "40px", marginTop: "6px" },
                  ]}
                ></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
          <View style={{ margin: "27px", height: "50%" }}>
            <View style={{ flexDirection: "row" }}>
              <View
                style={[
                  Styles.landscapeArrowContainer,
                  { alignSelf: "flex-start" },
                ]}
              ></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View style={{ height: "30px" }}></View>
                <View
                  style={{
                    height: "90%",
                    textAlign: "left",
                    transform: "rotate(180deg)",
                  }}
                >
                  {engChunks[1]?.map((word, idx) => {
                    return (
                      <Text style={{}} key={idx}>
                        {word}
                      </Text>
                    );
                  })}
                </View>
                <View style={{ height: "30px" }}></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.portraitPage}>
        <View style={Styles.portraitContainer}>
          <View style={{ margin: "27px", height: "50%" }}>
            <View style={{ flexDirection: "row" }}>
              <View style={{ width: "30px" }}></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View style={{ height: "30px" }}></View>
                <View
                  style={{
                    height: "90%",
                    textAlign: "left",
                    transform: "rotate(180deg)",
                  }}
                >
                  {engChunks[0]?.map((word, idx) => {
                    return (
                      <Text style={{}} key={idx}>
                        {word}
                      </Text>
                    );
                  })}
                </View>
                <View
                  style={[
                    Styles.landscapeArrowContainer,
                    { height: "30px", marginTop: "18px", marginRight: "-10px" },
                  ]}
                >
                  <View style={{ transform: "rotate(-90deg)" }}>
                    <Text style={[Styles.pointingText, { width: "40px" }]}>
                      Start of text
                    </Text>
                    <Image
                      src="/images/rightpdf_arrow.png"
                      style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
                    ></Image>
                  </View>
                </View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
          <View style={{ margin: "27px", height: "50%" }}>
            <View style={{ flexDirection: "row" }}>
              <View
                style={[
                  Styles.landscapeArrowContainer,
                  { alignSelf: "flex-start" },
                ]}
              ></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View
                  style={{
                    height: "30px",
                    justifyContent: "flex-end",
                    marginBottom: "6px",
                  }}
                >
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={[
                      Styles.arrowIcon,
                      { transform: "rotate(-90deg)", alignSelf: "flex-end" },
                    ]}
                  ></Image>
                </View>
                <View style={{ height: "90%" }}>
                  <View
                    style={[
                      {
                        textAlign: "right",
                      },
                    ]}
                  >
                    {arabicText(arabChunks[2])}
                  </View>
                </View>
                <View style={{ height: "30px" }}></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A5" orientation="landscape" style={Styles.landscapePage}>
        <View style={{ flexDirection: "row", textAlign: "right" }}>
          <View style={{ width: "30px", marginRight: "6px" }}>
            <View
              style={[
                Styles.landscapeArrowContainer,
                { position: "absolute", top: "92%" },
              ]}
            >
              <Text style={Styles.pointingText}>نهاية النص</Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={{ flexDirection: "column", width: "88%" }}>
            <View
              style={{
                height: "30px",
                justifyContent: "flex-end",
                marginBottom: "6px",
              }}
            >
              <Image
                src="/images/leftpdf_arrow.png"
                style={[
                  Styles.arrowIcon,
                  { transform: "rotate(-90deg)", alignSelf: "flex-end" },
                ]}
              ></Image>
            </View>
            <View style={{ height: "90%" }}>
              <View
                style={[
                  {
                    textAlign: "right",
                  },
                ]}
              >
                {arabicText(arabChunks[3])}
              </View>
            </View>
            <View style={{ width: "30px" }}></View>
          </View>
          <View style={{ width: "30px", marginLeft: "6px" }}></View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument28;
